import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { CommentEditData } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface UseUpdateCommentParams extends CommentEditData {
  commentId: string;
}

export const useUpdateComment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ commentId, text }: UseUpdateCommentParams): Promise<string> => {
      const result = await apiClient.comment.updateComment.mutation({
        params: { commentId },
        body: { text },
      });
      if (result.status !== 200) throw result.body;
      return result.body.message as string;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['comments'] });
      toast.success('Comment updated successfully!');
    },
    onError: (error) => {
      const originalError = (error as any).response?.data?.originalError;
      showErrorToast(error, originalError || 'Error updating the comment!');
    },
  });
};
